import { render, staticRenderFns } from "./TermListComponent.vue?vue&type=template&id=5e40a3f0"
import script from "./TermListComponent.vue?vue&type=script&lang=js"
export * from "./TermListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports